import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=15ec69bb&scoped=true&lang=pug"
import script from "./UserList.vue?vue&type=script&lang=ts"
export * from "./UserList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ec69bb",
  null
  
)

export default component.exports